module.exports = __webpack_public_path__ + "static/undraw_all_the_data_h4ki-f25f9720e1eff077d55cf80278b12f05.svg";